import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Card, CardContent, NO_DATA_PLACEHOLDER, TableContainer } from '@occc-app/design-system';
import { SteeringWalletFragment } from '@occc/graphql';
import { useGetWalletsForMembership } from '@occc-app/dataAccessLayer/steeringWallet/queries';
import { routeCreator as walletsRouteCreator } from '@occc-app/routes/Wallet/utils';

import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { MemberWalletsTable } from './MemberWalletsTable';
import { WALLETS_AFTER_PARAM, WALLETS_BEFORE_PARAM } from '../../constants';

type MemberWalletsProps = {
  membershipId: string;
};

export const MemberWallets: React.FC<MemberWalletsProps> = ({ membershipId }) => {
  const navigate = useNavigate();
  const [paginationInfo, onPageChange] = usePaginationParams({
    beforeParamName: WALLETS_BEFORE_PARAM,
    afterParamName: WALLETS_AFTER_PARAM,
  });

  const { loading, data, error, paginationProps } = useGetWalletsForMembership({
    membershipId,
    paginationInfo,
    onPageChange,
  });

  const onViewDetails = React.useCallback(
    (item: SteeringWalletFragment) => {
      navigate(walletsRouteCreator.details(item.uuid));
    },
    [navigate],
  );

  if (data?.length === 0) {
    return (
      <Card>
        <CardContent>{NO_DATA_PLACEHOLDER}</CardContent>
      </Card>
    );
  }

  return (
    <TableContainer sx={{ boxShadow: 'none' }}>
      <MemberWalletsTable
        wallets={data}
        loading={loading}
        error={error}
        onViewDetails={onViewDetails}
        paginationProps={paginationProps}
      />
    </TableContainer>
  );
};
